import { render, staticRenderFns } from "./ProjectMediaOverview.vue?vue&type=template&id=86221dae&"
import script from "./ProjectMediaOverview.vue?vue&type=script&lang=js&"
export * from "./ProjectMediaOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports